var _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8426_155471)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 10.5,
    stroke: "#1F1F1F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8426_155471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 21.75C17.8325 21.75 21.75 17.8325 21.75 13C21.75 8.16751 17.8325 4.25 13 4.25C8.16751 4.25 4.25 8.16751 4.25 13C4.25 17.8325 8.16751 21.75 13 21.75Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0418 16.7617C13.0279 16.7617 13.014 16.7755 12.9862 16.7755C12.9724 16.7755 12.9585 16.7617 12.9307 16.7617H13.0418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0409 18.169C18.4563 20.3324 15.8795 21.7517 12.9858 21.7517C10.0921 21.7517 7.52909 20.3462 5.93066 18.169C7.17082 16.8462 8.85192 16.1434 10.2574 15.7852C10.1334 16.7911 10.657 18.1415 10.6708 18.1001C11.1944 16.8875 12.972 16.7773 12.972 16.7773C12.972 16.7773 14.7496 16.8737 15.287 18.1001C15.3007 18.1277 15.8244 16.7911 15.7003 15.7852C17.1196 16.1434 18.8007 16.8462 20.0409 18.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1629 14.8597C15.1629 15.0389 15.0527 15.9897 13.0409 16.7613H12.9306C10.9188 15.9897 10.8086 15.0389 10.8086 14.8597C10.8224 14.5015 10.9051 14.1432 11.0566 13.8125C11.6078 14.4326 12.2692 14.846 12.9858 14.846C13.6885 14.846 14.3637 14.4464 14.9149 13.8125C15.0665 14.1432 15.1629 14.5015 15.1629 14.8597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1847 17.0805L13.7438 17.9624H12.2281L11.7871 17.0805C12.3934 16.8187 12.9859 16.7773 12.9859 16.7773C12.9859 16.7773 13.5922 16.8187 14.1847 17.0805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7598 21.6656C12.1594 21.7207 12.5728 21.7482 12.9999 21.7482C13.4133 21.7482 13.8267 21.7207 14.2401 21.6656L13.7578 17.9727H12.242L11.7598 21.6656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1635 14.832C15.1635 14.832 15.2599 15.9344 12.9863 16.7749C12.9863 16.7749 14.7639 16.8714 15.3013 18.0978C15.3151 18.1529 16.3485 15.4797 15.1635 14.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8087 14.832C9.63747 15.4797 10.6572 18.1391 10.6847 18.0978C11.2083 16.8852 12.9997 16.7749 12.9997 16.7749C10.7123 15.9344 10.8087 14.832 10.8087 14.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.026 14.0881C14.4473 14.7082 13.7583 15.1078 12.9866 15.1078C12.215 15.1078 11.526 14.7082 10.9473 14.0881C10.9748 13.9916 11.0162 13.8952 11.0575 13.8125C11.6087 14.4326 12.2701 14.846 12.9866 14.846C13.7032 14.846 14.3646 14.4464 14.9158 13.8125C14.9571 13.8952 14.9984 13.9916 15.026 14.0881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7479 11.9817C16.4585 12.464 16.0176 12.7534 15.6868 12.6983C15.0254 13.9246 14.0609 14.8341 12.9861 14.8341C11.9113 14.8341 10.9467 13.9109 10.2853 12.6983C9.95456 12.7396 9.51362 12.464 9.22425 11.9817C8.87976 11.4168 8.86598 10.7967 9.19669 10.59C9.27937 10.5487 9.36204 10.5211 9.4585 10.5349C9.67897 11.0998 9.98212 11.4443 9.98212 11.4443C9.66519 9.69433 10.9605 9.50141 10.74 7.82031C10.74 7.82031 11.553 9.62543 13.8817 8.35771L13.7026 8.7022C16.9546 7.97189 15.866 11.8026 15.8384 11.8991C16.2105 11.4305 16.4447 10.962 16.5825 10.5349C16.6376 10.5349 16.7065 10.5624 16.7479 10.59C17.1061 10.7829 17.0924 11.4168 16.7479 11.9817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8599 5.99863C15.1217 5.97107 15.5489 6.20532 15.5489 6.20532C14.3776 4.86871 12.4622 5.72304 12.4622 5.72304C13.1099 5.17186 13.6886 5.22698 13.6886 5.22698C10.9465 4.81359 10.478 6.45336 10.478 6.45336C10.354 6.26044 10.354 5.98485 10.3678 5.84706C10.1748 6.17777 10.3815 6.83918 10.3815 6.83918C10.1886 6.3569 9.51342 6.43958 9.51342 6.43958C10.0922 6.53603 10.1886 6.8943 10.1886 6.8943C8.74177 7.4317 8.9898 8.93367 8.9898 8.93367L9.33429 8.52029C8.90712 10.16 9.99571 11.4278 9.99571 11.4278C9.67878 9.67777 10.9741 9.48485 10.7536 7.80375C10.7536 7.80375 11.5666 9.60887 13.8953 8.34115L13.7162 8.68564C17.0095 7.94155 15.852 11.8963 15.852 11.8963C17.0233 10.4081 16.8441 8.87855 16.8441 8.87855L16.9819 9.42973C17.354 6.94942 14.8599 5.99863 14.8599 5.99863Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8426_155471",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8426_155471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8426_155471",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8426_155471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "translate(4.25 4.25)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d5d028251bd6623667c14d3b000f1cb9.svg";
export { ForwardRef as ReactComponent };